'use client';
import { Document } from '@contentful/rich-text-types';
import has from 'lodash/has';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

/**
 * Type guard to check if an object is a Contentful Rich Text Document
 */
export const isRichText = (x: Document | unknown): x is Document => {
    return ['data', 'content', 'nodeType'].every((prop) => has(x, prop));
};

/**
 * Simple renderer for rich text without advanced node renderers
 * Used to prevent circular dependencies
 */
export const simpleRichTextRender = (content: Document) => {
    return documentToReactComponents(content);
};
